import { BlockWrapper } from '@smartfire/js-block-engine'
import clsx from 'clsx'
import React, { useRef, useState } from 'react'
import { Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { allPostParams } from '../../types'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import style from './style.module.scss'
import 'swiper/css'

type crossPostProps = {
    title: string
    posts: allPostParams[]
    children: (post: allPostParams) => JSX.Element
}

export const CrossPost: React.FC<crossPostProps> = ({ title, posts, children }) => {
    const [greyed, setGreyed] = useState(-1)
    const isMobile = useMediaQuery('(max-width: ' + style.mobileBreakpoint + ')')
    const isTablet = useMediaQuery('(max-width: ' + style.tabletBreakpoint + ')')
    const isLaptop = useMediaQuery('(max-width: ' + style.laptopBreakpoint + ')')

    const swiperRef = useRef<any>(null)
    const swiperProps = {
        slidesPerView: isTablet ? (isMobile ? 1.085 : 2) : 3,
        slidesPerGroup: isTablet ? (isMobile ? 1 : 2) : 3,
        spaceBetween: isLaptop ? (isTablet ? (isMobile ? 15 : 30) : 45) : 60,
        autoplay: { delay: 6000, disableOnInteraction: false },
        pagination: { clickable: true },
        modules: [Autoplay],
    }

    const swipe = (next: number) => {
        if (next === 1) swiperRef?.current?.swiper.slideNext(400)
        else swiperRef?.current?.swiper.slidePrev(400)
    }

    const handleOnSlideChange = (e) => {
        if (e.isBeginning) setGreyed(-1)
        else if (e.isEnd) setGreyed(1)
        else setGreyed(0)
    }

    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.content}>
                <div className={style.top}>
                    <h2>{title}</h2>

                    <div className={style.navigation}>
                        <i
                            className={clsx(
                                'fi fi-rs-angle-small-left',
                                greyed === -1 && style.greyed,
                            )}
                            onClick={() => swipe(-1)}
                        ></i>
                        <i
                            className={clsx(
                                'fi fi-rs-angle-small-right',
                                greyed === 1 && style.greyed,
                            )}
                            onClick={() => swipe(1)}
                        ></i>
                    </div>
                </div>

                <Swiper
                    ref={swiperRef}
                    onSlideChange={handleOnSlideChange}
                    {...swiperProps}
                    className={style.swiper}
                >
                    {posts?.length > 0 &&
                        posts.map((post, i) => (
                            <SwiperSlide key={i} className={style.container}>
                                {children(post)}
                            </SwiperSlide>
                        ))}
                </Swiper>
            </div>
        </BlockWrapper.Div>
    )
}
